// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"353":"contact","757":"not-found"}[chunkId] + "." + {"353":"bddec9a0","757":"02c641fe"}[chunkId] + ".css";
};